module.exports = "/images/logo-santander-icon-2048.png?087d5587a713b1ca95f8867316432f95";